import React from 'react';
import { Route } from 'react-router';

import { VIEW_TYPES } from './Login/LoginForm/constants';
import { logout, revokeToken } from './actions';

const { LOGIN, PASSWORD_SET } = VIEW_TYPES;

const getComponent = (loc, cb, formView) => {
  return import('./Login/ConnectedLogin').then(c => {
    return cb(null, props => (
      <c.ConnectedLogin formView={formView} {...props} />
    ));
  });
};
const getResetPassword = (loc, cb) => getComponent(loc, cb, PASSWORD_SET);
const getLogin = (loc, cb) => getComponent(loc, cb, LOGIN);

export const getDealerLoginRoutes = ({ dispatch }) => {
  const onLogoutEnter = () => {
    return dispatch(logout());
  };

  const onRevokeTokenEnter = () => {
    return dispatch(revokeToken());
  };

  return (
    <>
      <Route path="/dealer/login" getComponent={getLogin} />
      <Route path="/dealer/logout" onEnter={onLogoutEnter} />
      <Route path="/dealer/reset-password" getComponent={getResetPassword} />
      <Route path="/dealer/revoke-token" onEnter={onRevokeTokenEnter} />
      <Route path="/" getComponent={getResetPassword} />
    </>
  );
};
